import { Component, NgModule, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { DxButtonModule } from 'devextreme-angular';
import { CatalogModule } from '../catalog-container/catalog/catalog.component';
import { AppInfoService } from '../../services/app-info.service';
import { CommonModule } from '@angular/common';
import { UserService } from '../../services/user/user.service';
import { SessionService } from '../../services/session.service';
import { CatalogConfigurationsService } from '../../services/catalog-configurations.service';

@Component({
  selector: 'app-catalog-trending',
  templateUrl: './catalog-trending.component.html',
  styleUrls: ['./catalog-trending.component.scss'],
})
export class CatalogTrendingComponent implements OnInit {
  trendingCatalog = true;
  catalogType = '';
  landingConfigs;
  totalResults = 0;
  facilityName: string = '';

  constructor(
    private router: Router,
    private appInfo: AppInfoService,
    private userService: UserService,
    private sessionService: SessionService,
    private catalogConfigsService: CatalogConfigurationsService,
  ) {}

  ngOnInit() {
    this.getLandingConfigs();
    this.getMe();
    this.watchPrimaryFacilityUpdatedTrigger();
  }

  watchPrimaryFacilityUpdatedTrigger() {
    const s = this.sessionService.primaryFacilityUpdatedTrigger.subscribe(() =>
      this.getMe(),
    );
  }

  getMe() {
    this.userService.getMe().subscribe(result => {
      result = result.data;
      this.facilityName = result.primary_facility.name;
    });
  }

  goToCatalog() {
    if (this.router.routerState.snapshot.url === '/catalog') {
      this.catalogConfigsService.reset();
    } else {
      this.router.navigate(['/catalog']);
    }
  }

  private getLandingConfigs() {
    this.appInfo.get().subscribe(result => {
      this.landingConfigs = result;
      if (this.landingConfigs.domainKey != 'medigi') {
        this.catalogType = this.landingConfigs.domainKey;
      } else {
        this.catalogType = '503b|medigi|medshorts';
      }
    });
  }

  populateTotalResults(e) {
    this.totalResults = e;
  }
}

@NgModule({
  imports: [CommonModule, CatalogModule, DxButtonModule],
  declarations: [CatalogTrendingComponent],
  exports: [CatalogTrendingComponent],
})
export class CatalogTrendingModule {}
